export default __webpack_public_path__ + "static/media/error.ed31514e.svg";